export default __webpack_public_path__ + "static/media/van.7ba1a8d6.svg";